<template>
  <span>
    {{ data.value.label ? data.value.label : data.value }}
  </span>
</template>

<script>
import BaseDisplayType from './Base.vue'

export default {
  name: 'ReferenceDisplayType',
  extends: BaseDisplayType,
}
</script>

<style scoped>

</style>
